import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAdminVideosAction,
  createAdminVideoAction,
  updateAdminVideoAction,
  completeVideoReplacementAction,
  deleteAdminVideoAction,
} from "../Actions";

const ADMIN_VIDEO_SLICE_NAME = "adminVideoDetails";

const adminVideoInitialState = {
  fetchAdminVideosData: {},
  // true only while the list itself is loading (drives table loading state)
  isLoading: false,
  // true while a mutating operation (create/update/replace/delete) is running
  isSaving: false,
  // edit flow: whether the add/edit page is in edit mode + the record to edit
  isEditVideo: false,
  editVideoData: {},
};

const adminVideoSlice = createSlice({
  name: ADMIN_VIDEO_SLICE_NAME,
  initialState: adminVideoInitialState,
  reducers: {
    isFromEditVideo(state, action) {
      state.isEditVideo = action.payload;
      return state;
    },
    isFromEditVideoData(state, action) {
      state.editVideoData = action.payload;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      // List
      .addCase(fetchAdminVideosAction.pending, (state) => {
        state.isLoading = true;
        return state;
      })
      .addCase(fetchAdminVideosAction.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fetchAdminVideosData = action.payload;
        return state;
      })
      .addCase(fetchAdminVideosAction.rejected, (state, action) => {
        state.isLoading = false;
        state.fetchAdminVideosData = action.payload;
        return state;
      })
      // Create
      .addCase(createAdminVideoAction.pending, (state) => {
        state.isSaving = true;
        return state;
      })
      .addCase(createAdminVideoAction.fulfilled, (state) => {
        state.isSaving = false;
        return state;
      })
      .addCase(createAdminVideoAction.rejected, (state) => {
        state.isSaving = false;
        return state;
      })
      // Update
      .addCase(updateAdminVideoAction.pending, (state) => {
        state.isSaving = true;
        return state;
      })
      .addCase(updateAdminVideoAction.fulfilled, (state) => {
        state.isSaving = false;
        return state;
      })
      .addCase(updateAdminVideoAction.rejected, (state) => {
        state.isSaving = false;
        return state;
      })
      // Replace (completion)
      .addCase(completeVideoReplacementAction.pending, (state) => {
        state.isSaving = true;
        return state;
      })
      .addCase(completeVideoReplacementAction.fulfilled, (state) => {
        state.isSaving = false;
        return state;
      })
      .addCase(completeVideoReplacementAction.rejected, (state) => {
        state.isSaving = false;
        return state;
      })
      // Delete
      .addCase(deleteAdminVideoAction.pending, (state) => {
        state.isSaving = true;
        return state;
      })
      .addCase(deleteAdminVideoAction.fulfilled, (state) => {
        state.isSaving = false;
        return state;
      })
      .addCase(deleteAdminVideoAction.rejected, (state) => {
        state.isSaving = false;
        return state;
      });
  },
});

export const { isFromEditVideo, isFromEditVideoData } = adminVideoSlice.actions;
export const adminVideoReducer = adminVideoSlice.reducer;
